import React from "react";
import * as Mui from "@mui/material";
import { designTokens } from "theme";

interface SectionHeaderProps {
	title: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ title }) => {
	return (
		<Mui.Typography
			style={{
				fontFamily: designTokens.typography.fontFamily,
				fontWeight: 700,
				fontSize: 18,
				lineHeight: 1.2,
				color: "#1c1b1f",
			}}
		>
			{title}
		</Mui.Typography>
	);
};
